import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import constants from "./plugins/Constants";
import moment from "moment";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$constants = constants;
Vue.prototype.moment = moment;

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
}).$mount("#app");
